module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/C8ManS/tc-custom/9780795351174.jpg?1725275240875",
      "alt": "This image is the cover for the book Sharon Sala Suspense Stories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sharon Sala Suspense Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Three romantic suspense novels from the #1 "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of the Jigsaw Files novels.")]), _c('br'), _c('br'), _c('b', [_vm._v("Butterfly")]), _c('br'), _vm._v(" A tough-as-nails detective is on the case of a murdered celebrity photographer—and hot for the star witness. But as things heat up and they grow closer to each other, the killer grows closer to them . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Bloodlines")]), _c('br'), _vm._v(" When a child’s skeleton is found hidden in a wall, Olivia Sealy’s past resurfaces. Her former sweetheart is the detective assigned to the case, which reminds her of the kidnapping ordeal she underwent as a child. Plus, there is the matter of the kidnapper the police never apprehended . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Mimosa Grove")]), _c('br'), _vm._v(" A Louisiana woman’s gift of second sight leads her to a missing girl, and the mystery man of her dreams . . ."), _c('br'), _c('br'), _c('b', [_vm._v("“[Sala] spins an intricate tale of treachery and terror.”—"), _c('i', [_vm._v("RT Book Reviews ")]), _vm._v("on "), _c('i', [_vm._v("Mimosa Grove")])])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Sala\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    RosettaBooks, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0